export default __webpack_public_path__ + "static/media/chat4.5ed92022.jpg";